import type { StaffRole } from '@/api/types'

/** What an item without an explicit role list needs: the trust & safety staff. SUPPORT is always listed explicitly. */
export const CORE_STAFF: readonly StaffRole[] = ['MODERATOR', 'ADMIN']

export const isStaffRole = (role?: string | null): role is StaffRole =>
  role === 'ROOT' || role === 'ADMIN' || role === 'MODERATOR' || role === 'SUPPORT'

/** ADMIN rights: ADMIN itself and ROOT (the owner account sees everything an admin sees). */
export const isAdminRole = (role?: string | null) => role === 'ADMIN' || role === 'ROOT'

/**
 * `roles` empty/undefined = MODERATOR or ADMIN (every page that predates the SUPPORT role). ROOT passes wherever
 * ADMIN is allowed.
 */
export function hasRole(role: string | null | undefined, roles?: readonly StaffRole[]) {
  if (!isStaffRole(role)) return false
  const allowed = !roles || roles.length === 0 ? CORE_STAFF : roles
  return allowed.includes(role) || (role === 'ROOT' && allowed.includes('ADMIN'))
}
